<template>
  <div
    class="refresh-button"
    :class="`refresh-button--${mode}`"
    @click="$emit('click')"
  >
    <div class="refresh-button__icon">
      <img :src="$options.REFRESH_ICON" />
    </div>
  </div>
</template>

<script>
import RefreshIcon from '@js-app/assets/transactions/actions/refersh.svg'

export default {
  name: 'RefreshButton',
  props: {
    mode: {
      type: String,
      default: 'base',
    },
  },
  REFRESH_ICON: RefreshIcon,
  emits: ['click'],
}
</script>

<style lang="scss" scoped>
.refresh-button {
  padding: 0 36px;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  &--plain {
    height: 44px;
  }

  cursor: pointer;
  position: relative;
  &:hover {
    opacity: 0.8;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__text {
    display: none;
  }

  &__options {
    position: absolute;
    background: #ffffff;
    box-shadow: 0px -5px 60px rgba(120, 140, 184, 0.1);
    border-radius: 8px;
    padding: 12px 0;

    top: calc(100% + 10px);
    z-index: 99;

    &-item {
      font-weight: 500;
      font-size: 12px;
      line-height: 36px;
      color: #47475e;
      padding: 0 16px 0 23px;
      white-space: nowrap;
    }
  }
}
</style>
